import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./userInfo.module.css";
import React from "react";
import {
  TTherapistUser,
  TTherapistWithUsers,
  TUserInfo,
} from "../../services/types/user.types";
import { calculateAge, mobileWidth, noDataLabel } from "../../utils/constants";
import useMediaQuery from "../../hooks/useMediaQuery";
import PhoneDialButton from "../phoneDialButton/PhoneDialButton";

function UserInfo({
  user,
  customClassName,
}: {
  user: TTherapistWithUsers | TTherapistUser | TUserInfo;
  customClassName?: string;
}) {
  const usersId = "usersId" in user ? (user as any).usersId : ("UsersId" in user ? (user as any).UsersId : (user as any).Id);
  const phone = (user as any)?.phone ?? (user as any)?.Phone;
  const mobile = useMediaQuery(mobileWidth);
  const userName: string =
  ("fullName" in user && typeof user.fullName === "string" && user.fullName) ||
  ("FullName" in user && typeof (user as any).FullName === "string" && (user as any).FullName) ||
  ("UserName" in user && typeof (user as any).UserName === "string" && (user as any).UserName) ||
  `${(user as any)?.firstName ?? (user as any)?.FirstName ?? ""} ${(user as any)?.lastName ?? (user as any)?.LastName ?? ""}`.trim() ||
  "";

  return (
    <section className={`${styles.userSection} ${customClassName}`}>
      <article className={styles.user}>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>
            {mobile ?  t('NAME') : t('DOCUMENT_LABEL_USER_NAME')}
          </p>
          <p className={styles.user__text}>
            {userName}
          </p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('CALENDAR_USER_NUMBER')}</p>
          <p className={styles.user__text}>{usersId}</p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>
            {t('AGE')}</p>
          <p className={styles.user__text}>
          {
            ((user as any).birth ?? (user as any).Birth) ?
              calculateAge((user as any).birth ?? (user as any).Birth)
              : t('PROFILE_NO_INFO')
          }
          </p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('DOCUMENT_LABEL_PHONE')}</p>
          <p className={`${styles.user__text} ${styles.user__phone}`}>
            <PhoneDialButton
              phone={phone != null ? String(phone) : undefined}
              fallback={noDataLabel}
              meta={{
                userId: usersId !== undefined ? Number(usersId) : undefined,
                guid: (user as any)?.guid ?? (user as any)?.Guid,
                firstName: (user as any)?.firstName ?? (user as any)?.FirstName,
                lastName: (user as any)?.lastName ?? (user as any)?.LastName,
              }}
            />
          </p>
        </div>
        {/* <UserInfoActions patientId={String(usersId)} /> */}
      </article>
    </section>
  );
}

export default UserInfo;
